import BackgroundEditor from './main.vue'

export * from './hooks'

export default BackgroundEditor
